import React , { memo }  from "react";
import PropTypes from "prop-types";
import { Offcanvas } from "react-bootstrap";
import Button from '../Button.jsx';
import "./features.common.styles.scss";

const Drilldown = ({
  modalOpen,
  modalHide,
  customSize,
  drillBody,
  subHeading,
  drilldownTitle,
  DrilldownCustomClass,
  customdrillClass,
  enableCustomScroll
}) => {
  return (
    <Offcanvas
      placement="end"
      className={`${DrilldownCustomClass} ${customSize}`}
      show={modalOpen}
      backdropClassName="drilldownThree_backdrop"
    >
      <Button
        className="btn-close text-reset"
        data-testid="drilldown-close-btn"
        text="×"
        onClick={modalHide}
      />
      <div className={`meanwrap ${enableCustomScroll ? 'custom_scroll' : ''} ${customSize}`}>
        <div className={`${customdrillClass}`}>
          <h3 className="flowhead">
            {drilldownTitle}
            {subHeading && <span>{subHeading}</span>}
          </h3>
          {drillBody()}
        </div>
      </div>
    </Offcanvas>
  );
};

Drilldown.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  modalHide: PropTypes.func.isRequired,
  customSize: PropTypes.string,
  drillBody: PropTypes.func.isRequired,
  subHeading: PropTypes.string,
  drilldownTitle: PropTypes.string.isRequired,
  DrilldownCustomClass: PropTypes.string,
  customdrillClass: PropTypes.string,
  enableCustomScroll: PropTypes.bool,
};

Drilldown.defaultProps = {
  customSize: "",
  subHeading: "",
  DrilldownCustomClass: "",
  enableCustomScroll: true,
};

export default memo(Drilldown);



